var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLetterSpacingSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1562_252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 1.99996V14C15 14.0884 14.9649 14.1732 14.9024 14.2357C14.8399 14.2982 14.7551 14.3333 14.6667 14.3333C14.5783 14.3333 14.4935 14.2982 14.431 14.2357C14.3685 14.1732 14.3333 14.0884 14.3333 14V1.99996C14.3333 1.91155 14.3685 1.82677 14.431 1.76426C14.4935 1.70174 14.5783 1.66663 14.6667 1.66663C14.7551 1.66663 14.8399 1.70174 14.9024 1.76426C14.9649 1.82677 15 1.91155 15 1.99996ZM1.33333 14.3333C1.42174 14.3333 1.50652 14.2982 1.56904 14.2357C1.63155 14.1732 1.66667 14.0884 1.66667 14V1.99996C1.66667 1.91155 1.63155 1.82677 1.56904 1.76426C1.50652 1.70174 1.42174 1.66663 1.33333 1.66663C1.24493 1.66663 1.16014 1.70174 1.09763 1.76426C1.03512 1.82677 1 1.91155 1 1.99996V14C1 14.0884 1.03512 14.1732 1.09763 14.2357C1.16014 14.2982 1.24493 14.3333 1.33333 14.3333ZM8.2982 4.51756L11.6315 11.1842C11.6711 11.2633 11.6776 11.3549 11.6496 11.4387C11.6216 11.5226 11.5615 11.592 11.4824 11.6315C11.4033 11.671 11.3118 11.6775 11.2279 11.6496C11.144 11.6216 11.0747 11.5614 11.0351 11.4824L9.79393 8.99996H6.20607L4.96487 11.4824C4.92533 11.5614 4.856 11.6216 4.77212 11.6496C4.68824 11.6775 4.59669 11.671 4.5176 11.6315C4.43851 11.592 4.37837 11.5226 4.3504 11.4387C4.32243 11.3549 4.32893 11.2633 4.36847 11.1842L7.7018 4.51756C7.73268 4.46604 7.77638 4.4234 7.82864 4.3938C7.8809 4.3642 7.93994 4.34864 8 4.34864C8.06006 4.34864 8.1191 4.3642 8.17136 4.3938C8.22362 4.4234 8.26732 4.46604 8.2982 4.51756ZM9.4606 8.33329L8 5.41209L6.5394 8.33329H9.4606Z",
    fill: "#9F9F9F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1562_252"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterSpacingSmall);
export default __webpack_public_path__ + "static/media/letter-spacing-small.001e3284077beebe77a572922d2a504c.svg";
export { ForwardRef as ReactComponent };